import type { IContentModel } from '~/features-shared/content/interfaces/content-model'

/**
 * Defines parameters needed to make exalead api call to fetch swym content
 */
export interface SearchOneElementExaleadOptions {
  /**
   * Unique Id of the content(Usually subject uri or it is content id if we are dealing with old v2 url format)
   */
  id: string
  /**
   * Derived type id
   */
  derivedTypeId?: string
  /**
   * Content type
   */
  contentType?: IContentModel
}

export enum DS6WStatus {
  Out = 'ds6w:status.swym_inactive',
}

export enum DS6WEvent {
  Published = 'swym:eventAction.swym_event_action_publish',
  Commented = 'swym:eventAction.swym_event_action_comment',
  Answered = 'swym:eventAction.swym_event_action_answer',
  Revised = 'swym:eventAction.swym_event_action_edit_wiki',
  Edited = 'swym:eventAction.swym_event_action_edit',
  Ended = 'swym:eventAction.swym_event_action_survey_closed',
  Started = 'swym:eventAction.swym_event_action_survey_opened',
  StatusChanged = 'swym:eventAction.swym_event_action_change_status',
  Validated = 'swym:eventAction.swym_event_action_validate',
}
